<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2fm"><a id="contents"></a><a id="page_ix"><span class="txbf">Contents</span></a></h2><a id="page_ix">
</a><p class="cont"><a id="page_ix"></a><a href="#/xhtml/epigraph">Epigraph</a></p>
<p class="cont"><a href="#/xhtml/maps">List of Maps</a></p>
<p class="cont"><a href="#/xhtml/prologue">Prologue: The View</a></p>
<p class="cont-part"><a href="#/xhtml/part01"><span class="txbf">PART I</span></a></p>
<p class="cont-partt"><a href="#/xhtml/part01"><span class="txbf">Antebellum</span></a></p>
<p class="cont-chap"><a href="#/xhtml/ch01">Chapter One: Foundering Father</a></p>
<p class="cont-chap"><a href="#/xhtml/ch02">Chapter Two: A Potomac Son</a></p>
<p class="cont-chap"><a href="#/xhtml/ch03">Chapter Three: Lee’s Union</a></p>
<p class="cont-part"><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="txbf">PART II</span></span></p>
<p class="cont-partt"><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="txbf">Casus Belli</span></span></p>
<p class="cont-chap"><span href="#/xhtml/ch04" title="Link target outside of Sample">Chapter Four: Half Slave, Half Free</span></p>
<p class="cont-chap"><span href="#/xhtml/ch05" title="Link target outside of Sample">Chapter Five: Washington’s Sword</span></p>
<p class="cont-chap"><span href="#/xhtml/ch06" title="Link target outside of Sample">Chapter Six: The Decision</span></p>
<p class="cont-part"><span href="#/xhtml/part03" title="Link target outside of Sample"><span class="txbf">PART III</span></span></p>
<p class="cont-partt"><span href="#/xhtml/part03" title="Link target outside of Sample"><span class="txbf">Bellum</span></span></p>
<p class="cont-chap"><span href="#/xhtml/ch07" title="Link target outside of Sample">Chapter Seven: The Battle for Arlington</span></p>
<p class="cont-chap"><span href="#/xhtml/ch08" title="Link target outside of Sample">Chapter Eight: The Last Heir</span></p>
<p class="cont-chap"><span href="#/xhtml/ch09" title="Link target outside of Sample">Chapter Nine: White House Burning</span></p>
<p class="cont-chap"><a id="page_x"></a><span href="#/xhtml/ch10" title="Link target outside of Sample">Chapter Ten: Emancipation</span></p>
<p class="cont-chap"><span href="#/xhtml/ch11" title="Link target outside of Sample">Chapter Eleven: The Indispensable Man</span></p>
<p class="cont-chap"><span href="#/xhtml/ch12" title="Link target outside of Sample">Chapter Twelve: The Cemetery</span></p>
<p class="cont-part"><span href="#/xhtml/part04" title="Link target outside of Sample"><span class="txbf">PART IV</span></span></p>
<p class="cont-partt"><span href="#/xhtml/part04" title="Link target outside of Sample"><span class="txbf">Postbellum</span></span></p>
<p class="cont-chap"><span href="#/xhtml/ch13" title="Link target outside of Sample">Chapter Thirteen: Washington and Lee</span></p>
<p class="contb"><span href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue: The Bridge</span></p>
<p class="cont"><span href="#/xhtml/photographs" title="Link target outside of Sample">Photographs</span></p>
<p class="cont"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cont"><span href="#/xhtml/appendix" title="Link target outside of Sample">Appendix: Custis-Lee Family Tree</span></p>
<p class="cont"><span href="#/xhtml/credits" title="Link target outside of Sample">Map and Illustration Credits</span></p>
<p class="cont"><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></p>
<p class="cont"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="cont"><span href="#/xhtml/bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="cont"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?122b2b3f